import { faCalendar, faMessage } from '@fortawesome/free-regular-svg-icons';
import { faCircle } from '@fortawesome/free-solid-svg-icons';

import { Status } from 'apps/shared/scripts/__generated__/graphql.generated';
import { formatDate } from 'apps/shared/scripts/utils';

import CardItemTag, { TagStatus } from './CardItemTag';
import { cardItemFooterClassName } from './styles';

interface Props {
  createdAt: string;
  postCount: number;
  status: Status;
}

const CardItemFooter = ({ createdAt, postCount, status }: Props) => {
  return (
    <div className={cardItemFooterClassName}>
      <CardItemTag faIcon={faCalendar} label={formatDate(createdAt)} />
      <CardItemTag
        faIcon={faMessage}
        label={`${postCount} ${postCount === 1 ? 'Post' : 'Posts'}`}
      />
      {status === Status.Published || status === Status.Sent ? (
        <CardItemTag
          faIcon={faCircle}
          label="Delivered"
          status={TagStatus.Info}
          iconAfter
        />
      ) : (
        <CardItemTag
          faIcon={faCircle}
          label="Active"
          status={TagStatus.Success}
          iconAfter
        />
      )}
    </div>
  );
};

CardItemFooter.displayName = 'CardItemFooter';

export default CardItemFooter;
